import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

class ScheduleTradesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      search_data: false,
      base_origin_id: null,
      base_destination_id: null,
      staff_id: null,
      role_id: null,
      aircraft_model_id: null,
      aircraft_model_subtype_id: null,
      license_id: null,
      date_start: null,
      date_finish: null,
      requester_reason: null,
      staffs_select: null,
      bases_select: null,
      bases_filtered_select: null,
      roles_select: null,
      aircraft_models_select: null,
      aircraft_model_subtypes_select: null,
      licenses_select: [
        {value: 'CHT - CEL', label: 'CHT - CEL'},
        {value: 'CHT - AVI', label: 'CHT - AVI'},
        {value: 'CHT - GMP', label: 'CHT - GMP'},
        {value: 'CCT - CEL', label: 'CCT - CEL'},
        {value: 'CCT - AVI', label: 'CCT - AVI'},
        {value: 'CCT - GMP', label: 'CCT - GMP'},
      ],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.search = this.search.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/solicitacoes/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staffs_select: responseJson.data.staffs_select,
            bases_select: responseJson.data.bases_select,
            bases_filtered_select: responseJson.data.bases_filtered_select,
            roles_select: responseJson.data.roles_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            aircraft_model_subtypes_select: responseJson.data.aircraft_model_subtypes_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }

  search (event) {
    event.preventDefault();
    var datasave = {
      base_origin_id: this.state.base_origin_id,
      base_destination_id: this.state.base_destination_id,
      staff_id: this.state.staff_id,
      role_id: this.state.role_id,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
      license_id: this.state.license_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      requester_reason: this.state.requester_reason,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/solicitacoes/pesquisar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success' || responseJson.status === 'warning') {
          self.handleAlert('', '', 'closed');
        }
        self.setState({search_data: responseJson.data});
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  add(data) {
    var confirm = window.confirm('Tem certeza de que deseja criar esta solicitação?');
    if (confirm) {
      var datasave = {
        base_origin_id: data.base_origin_id,
        base_destination_id: data.base_destination_id,
        aircraft_model_id: data.aircraft_model_id,
        staff_id: data.staff_id,
        date_start: data.date_start,
        date_finish: data.date_finish,
        requester_reason: data.requester_reason,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/solicitacao/colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
          }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastro de Solicitação</h3>
      <Link to="/solicitacoes/completo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Colaborador:</label>
            <Select
              className="form-field-name"
              name="staff_id"
              value={this.state.staff_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'staff_id')}
              options={this.state.staffs_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Justificativa:</label>
            <input type="text" className="form-control" name="requester_reason" value={this.state.requester_reason} onChange={this.handleChange.bind(this, 'requester_reason')} required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Início:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-6 form-group">
            <label>Término:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Base Origem:</label>
            <Select
              className="form-field-name"
              name="base_origin_id"
              value={this.state.base_origin_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_origin_id')}
              options={this.state.bases_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Base Destino:</label>
            <Select
              className="form-field-name"
              name="base_destination_id"
              value={this.state.base_destination_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_destination_id')}
              options={this.state.bases_filtered_select}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Função:</label>
            <Select
              className="form-field-name"
              name="role_id"
              value={this.state.role_id}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'role_id')}
              options={this.state.roles_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Habilitação:</label>
            <Select
              className="form-field-name"
              name="license_id"
              value={this.state.license_id}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'license_id')}
              options={this.state.licenses_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Frota Designada - Modelo:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_id"
              value={this.state.aircraft_model_id}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'aircraft_model_id')}
              options={this.state.aircraft_models_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Frota Designada - Motor:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_subtype_id"
              value={this.state.aircraft_model_subtype_id}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'aircraft_model_subtype_id')}
              options={this.state.aircraft_model_subtypes_select}
            />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Buscar colaboradores</button>
      </form>
      <hr/>
      {Array.isArray(self.state.search_data) &&
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th className="text-center">Colaborador</th>
              <th className="text-center">Base Origem</th>
              <th className="text-center">Função</th>
              <th className="text-center">Habilitação</th>
              <th className="text-center">Frota Designada - Modelo</th>
              <th className="text-center">Frota Designada - Motor</th>
              <th className="col-md-1 text-center">Ações</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.search_data).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.search_data[k].staff_name}</td>
                  <td className="text-center">{self.state.search_data[k].base_origin_name}</td>
                  <td className="text-center">{self.state.search_data[k].role}</td>
                  <td className="text-center">{self.state.search_data[k].licenses}</td>
                  <td className="text-center">{self.state.search_data[k].aircraft_models}</td>
                  <td className="text-center">{self.state.search_data[k].aircraft_model_subtypes}</td>
                  <td className="text-center">
                    <button className="btn bt-sm btn-primary" onClick={() => self.add(self.state.search_data[k])}><i className="fa fa-save fa-fw"></i></button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleTradesAdd;



// WEBPACK FOOTER //
// ./src/Components/ScheduleTrades/ScheduleTradesAdd.js